module.exports = __webpack_public_path__ + "static/media/GHS-CLP.14ffaea5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/products/GHS-CLP.svg
// module id = 84
// module chunks = 0